import { mercuryApi } from '$api'
import { SalesTax } from '$models'
import { getActiveCompanySettings } from '$utils'

const salesTaxBaseUrl = '/sales-tax'

/**
 * Get all tax rates, will be the custom rates if the user has them overridden otherwise will be the locale tax rates
 * @returns All tax rates
 */
export const getAllSalesTaxRates = async (): Promise<SalesTax[]> => {
  return await mercuryApi.get<SalesTax[]>(salesTaxBaseUrl)
}

/**
 * Gets the locale sales tax rates
 * @param locale the locale (e.g. 'en-NZ') of the company
 * @param province the province (e.g. 'QLD') of the company
 * @returns all locale sales tax rates
 */
export const getLocaleSalesTaxRates = async (
  locale: string,
  province: string | null
): Promise<SalesTax[]> => {
  const provinceQuery = province ? `&province=${province}` : ''
  return await mercuryApi.get<SalesTax[]>(
    `${salesTaxBaseUrl}?locale=${locale}${provinceQuery}`
  )
}

/**
 * Updates the company's Sale Taxe Rates
 * @param updatedSalesTax the updated SaleTax array
 * @returns the updated company sale tax rates
 */
export const updateSaleTaxRates = async (
  updatedSalesTax: SalesTax[]
): Promise<SalesTax[]> => {
  const { hasManagerPermission } = getActiveCompanySettings()

  if (!hasManagerPermission) return []

  return await mercuryApi.update(salesTaxBaseUrl, updatedSalesTax)
}
